import Core from '../plugin-core-system/core.class.js';

export default class CsResponsiveVideo extends Core {

  static options = {

  };

  /**
   * init responsive video
   */
  initResponsiveVideo() {
    const videos = document.querySelectorAll('.js-responsive-video');

    const setSources = (video) => {

      const source = video.querySelector('source');
      const { small, large } = video.dataset;

      let newSrc = '';

      /* @ToDo FE: use breakpoints from css config */
      if (window.innerWidth <= 820) {
        newSrc = small;
      } else {
        newSrc = large;
      }

      if (source.getAttribute('src') !== newSrc) {
        source.setAttribute('src', newSrc);
        video.load();
      }
    };

    const handleResize = () => {
      videos.forEach(video => {
        setSources(video);
      });
    };

    videos.forEach(video => {
      setSources(video);
    });

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        handleResize();
      }, 100);

    });
  }

  init() {
    this.initResponsiveVideo();
  }
}
